import { ApplicationType } from '@nimbus-library/features/configuration/application-type.enum';

export interface IEnvironment {
  production: boolean;
  applicationType: ApplicationType;
}

export abstract class IEnvironmentService {
  public abstract get environment(): IEnvironment;

  public get isApplicationAdmin(): boolean {
    return this.environment.applicationType === ApplicationType.Admin;
  }

  public get isApplicationPortal(): boolean {
    return this.environment.applicationType === ApplicationType.Portal;
  }

  public get isApplicationAssistant(): boolean {
    return this.environment.applicationType === ApplicationType.Assistant;
  }
}
